import { SalaryComponentUnit } from "@tymbe/legislatives/SalaryComponentUnit";

export const salaryComponentUnitNameMap: Record<SalaryComponentUnit, string> = {
  [SalaryComponentUnit.CZK]: "Koruny",
  [SalaryComponentUnit.Hour]: "Hodiny",
  [SalaryComponentUnit.Day]: "Dny",
}
